import toast from 'react-hot-toast';
import { postsApi } from 'src/api/posts';
import { fetchPostsById } from 'src/redux/slices/feedSlice';
import { AppDispatch } from 'src/redux/store/store';
import { poll } from 'src/utils/polling';

export const startPollingForVideoUrl = (
  videoId: string,
  circleId: string,
  dispatch: AppDispatch
) => {
  poll(
    () => postsApi.getPostsForCircle(circleId, 1).then((res) => res.result),
    {
      shouldStop: (posts) =>
        posts.some((post: any) => post.video_id === videoId && post.video_url),
      onSuccess: () => {
        toast.success('Your video is now available!');
        dispatch(fetchPostsById({ id: circleId, page: 1 }));
      },
      onError: () => {
        toast.error('Video upload timed out. Try again later.');
      },
      intervalMs: 4000,
      maxTries: 36,
    }
  );
};
